import { DeleteOutlined, EditOutlined, KeyOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Input, Layout, message, Modal, Pagination, Popconfirm, Row, Select, Space, Spin, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useRef, useState } from "react";
import FileUpload, { FileUploadRef } from "../../../../components/file-input/FileUpload";
import { FilterRequest, OrderTypes, OrderValue } from "../../../../utils/Filters/FilterModels";
import FilterHelper from "../../../../utils/Filters/FilterHelper";
import axiosInstance from "../../../../api/axiosInstance";
import { User } from "../../../../services/users/user";
import { Club } from "../../../../services/club/club";
import { useNavigate } from "react-router-dom";
const { TextArea } = Input;
const { Content } = Layout;
const API_URL = process.env.REACT_APP_API_URL;

const ClubManagement = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [tableHeight, setTableHeight] = useState(500);
    const [data, setData] = useState<Club[]>([]);
    const [searchText, setSearchText] = useState("");
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [filter, setFilter] = useState<FilterRequest>(new FilterRequest({
        page: 1,
        limit: 10,
        keyword: '',
        summary: '',
        filters: [],
        // orders: [
        //     new OrderValue({ propertyName: 'createdDate', type: OrderTypes.Desc, index: 0 }),
        //     new OrderValue({ propertyName: 'status', type: OrderTypes.Asc, index: 0 })
        // ],
        isFull: false,
        tree: false,
    }));

    useEffect(() => {
        const width = window.innerWidth;
        if (width <= 1366) setTableHeight(250);
        else setTableHeight(500);
    }, []);

    useEffect(() => {
        const params = FilterHelper.getParamWithFilter(filter);
        fetchClubs(params);
    }, []);

    const fetchClubs = async (paramValues?: any) => {
        try {
            setLoading(true);
            const response = await axiosInstance.get("/club", {
                params: paramValues ?? filter,
            });
            const items = response.data?.list || [];
            setTotalRecords(response.data?.totalRecords || 0);
            const formattedData: Club[] = items.map((item: any) => ({
                clubName: item.clubName,
                clubCode: item.clubCode,
                clubID: item.clubID
            }));

            setData(formattedData);
        } catch (error: any) {
            console.error("Lỗi khi lấy danh sách giải đấu:", error.response?.data || error.message);
        } finally {
            setLoading(false);
        }
    };

    const handlePaginationChange = (page: number, pageSize: number) => {
        const newFilter = new FilterRequest({
            ...filter,
            page,
            limit: pageSize,
        });
        setFilter(newFilter);
        const params = FilterHelper.getParamWithFilter(newFilter);
        fetchClubs(params);
    };
    const handleCreateClub = () => {
        navigate(`club-detail-management/new`);

    }

    const handleReloadClub = () => {
        const params = FilterHelper.getParamWithFilter(filter);
        fetchClubs(params);
    }
    const handleEditClub = (record: Club) => {
        navigate(`club-detail-management/${record.clubID}`);
    };

    const handleDeleteClub = async (record: Club) => {
        try {
            await axiosInstance.put(`/club/delete-club`, { ClubIDs: [record.clubID] });
            message.success("Xoá blog thành công!");
            const params = FilterHelper.getParamWithFilter(filter);
            fetchClubs(params);
        }
        catch (error: any) {
            message.error(error?.response?.data?.systemMessage || "Có lỗi xảy ra khi xóa.");
        }
    }

    const columns: ColumnsType<any> = [
        { title: "Mã câu lạc bộ", dataIndex: "clubCode", key: "clubCode", width: 200 },
        { title: "Tên câu lạc bộ", dataIndex: "clubName", key: "clubName" },
        {
            title: "Được sử dụng", align: 'center', dataIndex: "isActive", key: "isActive", width: 150, render: (text: any, record: any) => { let color = record.isActive === false ? "#F42121" : "#07BD74"; return <span style={{ color }}>{(text === false ? "Ngừng hoạt động" : "Đang hoạt động")}</span> }
        },
        {
            title: "Hành động",
            key: "action",
            width: 150,
            render: (_: any, record: Club) => (
                <Space>
                    <Button icon={<EditOutlined />} onClick={() => handleEditClub(record)} />
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xóa?"
                        onConfirm={() => handleDeleteClub(record)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const filteredData = data.filter(
        (blog) =>
            blog?.clubName?.toLowerCase().includes(searchText)
    );

    return (
        <Content style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
            <div
                style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff",
                    zIndex: 999,
                    padding: "16px",
                    borderBottom: "1px solid #ddd",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
            >
                <Space style={{ width: "100%" }}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{ backgroundColor: "#F48100", borderColor: "#F48100" }}
                        onClick={handleCreateClub}
                    >
                        Thêm mới
                    </Button>
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={handleReloadClub}
                    >
                        Làm mới
                    </Button>
                </Space>
            </div>
            <div style={{ flex: 1, overflow: "auto", marginTop: "16px" }}>
                {loading ? (
                    <Spin fullscreen tip="Đang tải dữ liệu..." size="large" />
                ) : (
                    <Table
                        columns={columns}
                        onRow={(record) => ({
                            onClick: (e) => {
                                const actionColumnIndex = columns.findIndex((col) => col.key === 'action');
                                const clickedColumn = (e.target as HTMLElement).closest('td');

                                if (clickedColumn && clickedColumn.cellIndex === actionColumnIndex) {
                                    return;
                                }
                            },
                        })}
                        dataSource={filteredData}
                        pagination={false}
                        scroll={{ y: tableHeight }}
                    />
                )}
            </div>
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#fff",
                    paddingTop: "10px",
                    borderTop: "-1px solid #ddd",
                    boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
                    textAlign: "center",
                }}
            >
                <Pagination
                    current={filter.page}
                    pageSize={filter.limit}
                    total={totalRecords}
                    onChange={handlePaginationChange}
                    showTotal={(total, range) =>
                        `Hiển thị ${range[0]} - ${range[1]} của ${total} bản ghi`
                    }
                />
            </div>
        </Content>
    )
}
export default ClubManagement